module.exports = __webpack_public_path__ + "static/assets/e28b110fa5eef35531fa271a3a7b6314.svg";